import React from 'react';

import type { FtuxTargetId } from '../targets';
import { Root } from './FtuxTarget.styles';

export type FtuxTargetProps = {
  /** The FTUX target the wrapped control is. */
  id: FtuxTargetId;
  /** The control spans its row (a full-width button, such as Game Lists' Add list or Affiliates' Invite affiliate). */
  fill?: boolean;
  children: React.ReactNode;
};

/**
 * Marks a control that cannot carry `data-ftux` itself (the shared Button and Toggle forward no data-* attribute):
 * a span round it carries the target, hugging it so its box is the control's. Inert outside an FTUX step.
 */
export const FtuxTarget = ({ id, fill = false, children }: FtuxTargetProps): React.ReactElement => (
  <Root data-ftux={id} $fill={fill}>
    {children}
  </Root>
);

export default FtuxTarget;
